import { ref } from 'vue';
import * as api from '../../services/user';
import { getLoginPath } from '@/utils/uri';
import { removeToken } from '@/utils/token';

export function useHeader() {
  const user = ref({});
  user.value.userName = '未登录';
  function showLogin() {
    const _loginBtn = document.body.querySelector('#passport-login');
    const event = new MouseEvent('click', {
      'view': window,
      'bubbles': true,
      'cancelable': true,
    });

    _loginBtn.dispatchEvent(event);
  }


  function logout() {
    api.keyanLogout()
      .then(
        () => {
          console.log('logout success');
        },
        rej => {
          console.log('logout fail', rej);
        }
      ).finally(() => {
        removeToken();
        location.href = getLoginPath();
      });
  }

  return {
    user,
    showLogin,
    logout
  };
}